module.exports = __webpack_public_path__ + "img/loader.3e05a241.gif";